import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, Form } from "redux-form";
import {
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonButton,
} from "@ionic/react";

import { FormInput, FormDatetimeInput } from "../../../common";
import { required } from "../../../common/validations";
import strings from "../../../../res/strings";

const AccountInformationForm = (props) => {
  return (
    <Form id="user-information-form" onSubmit={props.handleSubmit}>
      <div className="user-information-form">
        <IonItemGroup>
          <IonItemDivider color="primary">
            {strings.lib_account_header_information_personal}
          </IonItemDivider>
          <IonItem>
            <IonLabel position="floating">
              {strings.lib_account_label_name_first}
            </IonLabel>
            <Field
              name="first_name"
              label={strings.lib_account_label_name_first}
              type="text"
              component={FormInput}
              required
            />
          </IonItem>
          <IonItem>
            <IonLabel position="floating">
              {strings.lib_account_label_name_middle}
            </IonLabel>
            <Field
              name="middle_name"
              label={strings.lib_account_label_name_middle}
              type="text"
              component={FormInput}
              required
            />
          </IonItem>
          <IonItem>
            <IonLabel position="floating">
              {strings.lib_account_label_name_last}
            </IonLabel>
            <Field
              name="last_name"
              label={strings.lib_account_label_name_last}
              type="text"
              component={FormInput}
              required
            />
          </IonItem>
          <IonItem>
            <IonLabel position="floating">
              {strings.lib_account_label_birthdate}
            </IonLabel>
            <Field
              name="birthdate"
              label={strings.lib_account_label_birthdate}
              component={FormDatetimeInput}
              validate={[required]}
              required
            />
          </IonItem>
        </IonItemGroup>

        <IonItemDivider color="primary">
          {strings.lib_account_header_information_contact}
        </IonItemDivider>
        <IonItem>
          <IonLabel position="floating">
            {strings.lib_account_label_contact_mobile}
          </IonLabel>
          <Field
            name="contact_mobile"
            label={strings.lib_account_label_contact_mobile}
            type="text"
            required
            component={FormInput}
          />
        </IonItem>
        <IonItem>
          <IonLabel position="floating">
            {strings.lib_account_label_contact_landline}
          </IonLabel>
          <Field
            name="contact_landline"
            label={strings.lib_account_label_contact_landline}
            type="text"
            required
            component={FormInput}
          />
        </IonItem>
        <IonItem>
          <IonLabel position="floating">{"Preferred Contact Email"}</IonLabel>
          <Field
            name="contact_email"
            label={"Preferred Contact Email"}
            type="email"
            required
            component={FormInput}
          />
        </IonItem>
        <div style={{ padding: "16px" }}>
          <IonButton
            type="submit"
            color="success"
            style={{
              width: "100%",
              marginTop: "16px",
              marginBottom: "16px",
            }}
          >
            {strings.lib_common_action_submit}
          </IonButton>
        </div>
      </div>
    </Form>
  );
};

let ReduxAccountInformationForm = reduxForm({
  form: "lib_account_account_information_form",
  enableReinitialize: true,
})(AccountInformationForm);

const mapStateToProps = (state) => ({
  accountInformationForm: state.form.lib_account_account_information_form,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

ReduxAccountInformationForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxAccountInformationForm);

export default ReduxAccountInformationForm;
